/**
 * /dashboard/accounting/items — Items list (G_ACC3b).
 *
 * Migration note (Phase 3e — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/accounting/items/page.tsx.
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { Package, Plus } from "lucide-react";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { ItemList } from "@/components/accounting/item-list";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/accounting/items/")({
  component: ItemsListRoute,
});

function ItemsListRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <AccountingModuleShell
      title="Items"
      description="Goods and services you sell or buy — used on invoices and bills."
      actions={
        <Button asChild className="gap-1.5">
          <Link to="/app/$tenantSlug/accounting/items/new" params={{ tenantSlug }}>
            <Plus aria-hidden className="h-4 w-4" />
            Add item
          </Link>
        </Button>
      }
    >
      <div className="mb-2 flex items-center gap-2 text-sm text-muted-foreground sm:hidden">
        <Package aria-hidden className="h-4 w-4" />
        <span>Accounting</span>
      </div>
      <ItemList />
    </AccountingModuleShell>
  );
}
